<template>
  <div
    class="side-cart-sku-item"
    :class="{
      processingBg: item.cartStatus === 0,
      'side-cart-sku-item--disabled': item.disabled
    }"
  >
    <div class="sku-image-wrapper">
      <Image
        class="sku-image"
        :src="item.skuImageUrl"
        alt=""
      />
      <img
        src="@/assets/carts/selected.svg"
        class="checked"
        v-if="item.checked"
        @click="handleCheck"
      >
      <CartsSelect
        v-else
        @click="handleCheck"
        class="checked"
        :disabled="item.disabled"
      />
      <div
        v-if="item.cartStatus === 0"
        class="processing-flag"
      >
        Processing
      </div>
    </div>
    <div
      class="sku-attr"
      :title="item.skuSpec"
    >
      {{ item.skuSpec }}
    </div>
    <div
      :class="{ 'price-processing': item.cartStatus === 0 }"
      class="sku-price"
    >
      <IntlCurrency :currency="currency.current.targetCurrency" />
      {{ price }}
    </div>
    <div class="sku-options">
      <div class="counts-wrapper">
        <!-- 当 skuType 为 2（服务）时，该 sku 数量只能为 1 -->
        <NumberInput
          v-model="item.quantity"
          :disabled-minus="item.disabled || item.quantity <= item.bundleQuantity"
          :disabled-plus="item.disabled"
          :min="1"
          :max="item.skuType === 2 ? 1 : undefined"
          :step="item.bundleQuantity"
        />
      </div>
      <div
        @click="handleDeleteClick()"
        class="delete-icon"
      >
        <img
          src="@/assets/order/delete-icon.svg"
          width="20px"
          alt=""
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { useCartSku } from '@/views/Carts/hooks/useCartSku'
import NumberInput from '@/components/NumberInput/index.vue'
import CartsSelect from '@/views/Carts/components/CartsSelect.vue'
import { IntlCurrency } from '../NewIntlCurrency'

import { useCurrencyStore } from '@/pinia/currency'
import { Image } from '../Image'

const props = defineProps({
  item: {
    type: Object,
    required: true
  }
})

const currency = useCurrencyStore()

const { price, handleCheck, handleDeleteClick } = useCartSku(computed(() => props.item))
</script>

<style lang="less" scoped>
.side-cart-sku-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 8px 12px 8px;

  &.processingBg {
    background-color: #FFFCF7;
    border-radius: 8px;
  }

  &--disabled {
    .sku-image-wrapper,
    .sku-attr,
    .sku-price,
    .counts-wrapper {
      filter: grayscale(1) opacity(.5);
    }
  }

  .sku-image-wrapper {
    position: relative;
    width: 108px;
    height: 108px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #EBF1F5;
    .sku-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .checked {
      font-size: 24px;
      width: 24px;
      height: 24px;
    }
    .unselect, .checked {
      position: absolute;
      top: 4px;
      left: 4px;
      cursor: pointer;
    }
    .processing-flag {
      position: absolute;
      bottom: 0;
      height: 24px;
      width: 100%;
      background-color: #FFA033;
      color: white;
      font-size: 11px;
      font-family: mon-500;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
    }
  }
  .sku-attr {
    color: #6E717A;
    font-size: 11px;
    font-family: mon-500;
    line-height: 14px;
    margin-top: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    text-align: center;
    padding: 0 8px;
  }
  .sku-price {
    margin-top: 4px;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    color: #232323;
    font-family: mon-700;
    &.price-processing {
      color: #6e717a;
    }
  }
  .sku-options {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    margin-top: 6px;
    .counts-wrapper {
      width: 76px;
      height: 24px;

      :deep(.round-button) {
        width: 24px;
        height: 24px;
      }
    }
    .delete-icon {
      height: 18px;
      cursor: pointer;
      img {
        width: 18px;
      }
    }
  }
}
</style>
